import React from "react";
import "../App.css";
import { Link, withRouter, matchPath } from 'react-router-dom'
import Aux from "./AuxFunctions";
/* import 'reactjs-popup/dist/index.css'; */
import Popup from 'reactjs-popup';

import { withMyDataContext } from "../context/DataProvider";

import Notifications from "./Notifications/Notifications";
import Colors from "./Colors";
import PlusIcon from "mdi-react/PlusIcon"
import NotificationIcon from 'mdi-react/BellOutlineIcon';
import NotificationFilledIcon from 'mdi-react/BellIcon';
import MessagesIcon from "mdi-react/MessageOutlineIcon"
import MessagesFilledIcon from "mdi-react/MessageIcon"
import DialogModal from "./Utilities/DialogModal";
import MenuIcon from "mdi-react/MenuIcon"

import SearchBar from "./Utilities/SearchBar";

class TopBar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            openProfileMenu: false,
            notificationsData: [],
            finished: false,
            loading: false,
            newNotifications: false,
            lastVisible: null,
            logoutDialog: false,
            notificationHover: false,
            messagesHover: false,
            profileHover: false,

            tags: [],
            usersData: [],
            searchText: "",
            isLoading: false,
            isUser: true,

            showSearchBar: false,

            loadingUsers: false,
            loadingTags: false,

        }
        this.popupModal = null;
        this.profilePopup = this.profilePopup.bind(this)
        this.notificationIcon = this.notificationIcon.bind(this)
        this.notificationsPopup = this.notificationsPopup.bind(this)
        //const activeLink = this.props.match.params.category ? this.props.match.params.category : ""
    }

    notificationsListener = null;

    topBarStyle = {
        position: "sticky",
        top: 0,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        height: 60,
        backgroundColor: "white",
        // borderBottom: `1px solid ${this.props.styles.black(0.1)}`,
        fontWeight: "bold",
        boxSizing: "border-box",
        zIndex: 90,
    };

    getPathname = (type) => {
        const matchCat = matchPath(this.props.history.location.pathname, {
            path: '/:category',
            exact: false,
            strict: false
        })

        if (matchCat) {
            let cat = matchCat.params.category
            if (cat !== "top" && cat !== "trending" && cat !== "latest") {
                return "/" + cat + "/" + type
            }
            else {
                return "/" + type
            }
        } else {
            return "/" + type
        }

    }

    logout = () => {
        try {
            // Fire.shared.signOutUser();
            this.props.myDataProvider.signOut();
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goToSettings = () => {
        try {
            this.props.history.push("/settings")
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goToProfile = () => {
        try {
            this.props.history.push("/account/profile")
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goToEditProfile = () => {
        try {
            this.props.history.push("/account/edit")
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goToInviteFriends = () => {
        try {
            this.props.history.push("/account/invitefriends")
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goToAchievements = () => {
        try {
            this.props.history.push("/account/achievements")
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goToDailyRewards = () => {
        try {
            this.props.history.push("/account/daily")
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goToMessages = () => {
        try {
            this.props.history.push("/messages")
        } catch (error) {
            Aux.handleError(error)
        }
    }

    profileRender = () => {
        return (
            <div style={{ display: "flex", textDecoration: "none", cursor: "pointer", borderRadius: "50%", border: this.state.profileHover ? "2px solid #bbb" : "2px solid transparent", borderColor: this.state.profileHover ? Colors.mainColor : "transparent" }}
                onMouseEnter={() => this.setState({ profileHover: true })}
                onMouseLeave={() => this.setState({ profileHover: false })} >
                {Aux.showAvatar(40, this.props.myDataProvider.user.avatar, this.props.myDataProvider.user.username || "unknown")}
            </div>
        )
    }

    profilePopup() {
        return (
            <Popup
                // trigger={<div className="menu-item"> Sub menu </div>}
                trigger={<div className="top-bar-avatar"><this.profileRender></this.profileRender></div>}
                position="bottom right"
                closeOnDocumentClick
                contentStyle={{ padding: '0px', border: 'none', }}
                arrow={true}>
                <div className="menu">
                    <div className="menu-item" onClick={this.goToProfile}>Profile</div>
                    <div className="menu-item" onClick={this.goToEditProfile}>Edit Profile</div>
                    <div className="menu-item" onClick={this.goToInviteFriends}>Invite Friends</div>
                    <div className="menu-item" onClick={this.goToAchievements}>Achievements</div>
                    <div className="menu-item" onClick={this.goToDailyRewards}>Daily Rewards</div>
                    <div className="menu-item" onClick={this.goToSettings}>Settings</div>
                    <div className="menu-item" onClick={() => this.setState({ logoutDialog: true })}>Logout</div>
                </div>
            </Popup>
        )
    }

    notificationsPopup() {
        let windowWidth = typeof window !== "undefined" ? window.innerWidth : 0;
        const isMobile = windowWidth < 800
        return (
            <Popup
                // trigger={<div className="menu-item"> Sub menu </div>}
                trigger={<div><this.notificationIcon></this.notificationIcon></div>}
                position={"bottom right"}
                closeOnDocumentClick
                modal={isMobile}
                contentStyle={{ padding: '0px', overflowY: "hidden", overflowX: "hidden", width: 400, height: isMobile ? "90%" : 400, borderRadius: 10 }}
                arrow={false}>
                {close => (
                    <div id="scrollable-notifications" style={{ height: "100%" }}>
                        <Notifications close={close} isMobile={isMobile}></Notifications>
                    </div>)}
            </Popup>
        )
    }

    messagesIcon =() =>{
        return (
            <div style={{ display: "flex", }} onClick={this.goToMessages}>
                <div style={{ textDecoration: "none", margin: "auto", cursor: "pointer", position: "relative" }}
                    onMouseEnter={() => this.setState({ messagesHover: true })}
                    onMouseLeave={() => this.setState({ messagesHover: false })} >
                    {this.state.messagesHover ?
                        <MessagesFilledIcon size="30" style={{ margin: "auto", color: Colors.mainColor }} />
                        :
                        <MessagesIcon size="30" style={{ margin: "auto", color: "lightblue", }} />}
                {this.props.myDataProvider.newMessage ?
                        <div style={{ height: 5, width: 5, borderRadius: "50%", backgroundColor: "red", position: "absolute", top: 0, right: 0 }} />
                        : null}
                </div>
            </div>
        )
    }

    notificationIcon() {
        return (
            <div style={{ display: "flex", }} >
                <div style={{ textDecoration: "none", margin: "auto", cursor: "pointer", position: "relative" }}
                    onMouseEnter={() => this.setState({ notificationHover: true })}
                    onMouseLeave={() => this.setState({ notificationHover: false })} >
                    {this.state.notificationHover ?
                        <NotificationFilledIcon size="30" style={{ margin: "auto", color: Colors.mainColor }} />
                        :
                        <NotificationIcon size="30" style={{ margin: "auto", color: "lightblue", }} />}
                    {this.props.myDataProvider.newNotifications ?
                        <div style={{ height: 5, width: 5, borderRadius: "50%", backgroundColor: "red", position: "absolute", top: 0, right: 0 }} />
                        : null}
                </div>
            </div>
        )
    }


    getNewNotifications = async () => {
        try {
            this.props.myDataProvider.getNotifications(false);
        } catch (error) {
            Aux.handleError(error);
        }
    }

    onEnterPressed = (e) => {
        if (e.key === "Enter") {
            this.onSearch()
        }
    }

    render() {
        return (
            <div className="bottom-border" style={this.topBarStyle}>
                <DialogModal active={this.state.logoutDialog} onConfirm={this.logout} onClose={() => this.setState({ logoutDialog: false })} text="Are you sure you want to Logout?" />
                <div style={{ display: "flex", alignItems: "center", height: "100%",  overflow:"hidden" }}>
                    <div className="menu-mobile-main" style={{ height: "100%" }}>
                        <MenuIcon className="menu-mobile" onClick={this.props.toggleOpen} style={{ height: "100%", padding: "0 20px", }} ></MenuIcon>
                    </div>
                    <div className="menu-logo-main" style={{ paddingLeft: 20, margin: 2, alignSelf: "center" }}>
                        <img alt="logo" src={Aux.LogoImage} style={{ width: 20, objectFit: "contain" }}></img>
                    </div>
                    <Link style={{ color: "black", textDecoration: "none", marginLeft: 20, overflow:"hidden" }} to="/" >

                        
                        <h3 style={{overflow:"hidden", textOverflow:"ellipsis"}}> { this.props.myDataProvider.currentHashtag ? "#" + this.props.myDataProvider.currentHashtag : "Richless"}</h3>
                        {/* {this.props.docked ?  <h3>Richless</h3> : <img alt="logo" src={Aux.LogoImage} style={{ width: 20, objectFit: "contain" }}></img>}*/}
                    </Link>

                </div>
                
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{marginRight:20}}>
                        <SearchBar ></SearchBar>
                    </div>
                    {this.props.myDataProvider.isLoggedIn ?
                        <div style={{ margin: "auto", marginRight: 20, display: "flex", alignItems: "center" }}>
                            
                            {/* <div style={{ marginLeft: 20 }}>
                                <this.profilePopup></this.profilePopup>
                            </div> */}
                            <div style={{ }}>
                                <this.messagesIcon></this.messagesIcon>
                            </div>
                            <div style={{ marginLeft: 20 }}>
                                <this.notificationsPopup />
                            </div>
                        </div>
                        :
                        <div style={{ display: "flex" }}>
                            <Link className="topbar-button-hover" style={{ color: "white", backgroundColor: Colors.mainColor, borderRadius: 10, textDecoration: "none", marginRight: 30, display: "flex", alignItems: "center", padding: "10px 15px",}}
                                to="/account/login">
                                <h4>Enter</h4>
                            </Link> 
                        </div>
                    }

                    {this.props.myDataProvider.isLoggedIn ?
                        <Link style={{ color: "white", backgroundColor: Colors.mainColor, borderRadius: 10, border: " 2px solid", borderColor: Colors.mainColor, textDecoration: "none", marginRight: 20, display: "flex", alignItems: "center", height: 40, padding: "0px 10px" }}
                            to="/create" className="top-bar-create">
                            <PlusIcon ></PlusIcon>
                            <span className="top-bar-create-text">Create</span>
                        </Link>
                        :
                        <div>
                        {/* <Link className="topbar-button-hover" style={{ color: "white", backgroundColor: Colors.mainColor, borderRadius: 10, textDecoration: "none", marginRight: 20, display: "flex", alignItems: "center", height: 45, padding: "0px 15px" }}
                            to="/account/register">
                            <h4>Register</h4>
                        </Link> */}</div>}
                </div>

            </div>
        );
    }
};

export default withMyDataContext(withRouter(TopBar));

